let origin = "https://future.zhuneng.cn";
//获取二维码
const getCodeUrl = `/gateway/hc-external/hfCode/getUserQrCode`;

export { getCodeUrl };
